import { useSelector } from 'react-redux';
import { useGetConfigurationByPlantQuery } from "Services/Admin";
import { useGetInventorySummaryQuery } from 'Services/Admin/DashboardApiSlice';
import { RootState } from 'State/store';

interface InventoryStockProps {
  warehouse: string;
  categoryId: string;
  productId: string;
  mockMultiplier?: number;
}

export const InventoryStock = ({ warehouse, categoryId, productId }: InventoryStockProps) => {
  const plant = process.env.REACT_APP_PLANT || '';
  const adminToken = useSelector((state: RootState) => state.adminlogin.adminToken);
  const { data: config } = useGetConfigurationByPlantQuery(plant, { skip: !adminToken });
  const { data: stockData, isLoading } = useGetInventorySummaryQuery({
    plant, warehouse, categoryId, productId
  }, { pollingInterval: 60000 });

  const results = stockData?.results || {};
  // Using configuration decimal or default to 2
  const dec = config?.numberOfDecimal ? parseInt(config.numberOfDecimal) : 2;

  // Formatter to show full decimal precision exactly as returned by API
  const formatValue = (val: any) => {
    const num = Number(val) || 0;
    // Removed Cr/L units as per user request to show exact numeric value
    return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec })}`;
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 h-full flex flex-col min-h-[190px]">
      <h3 className="text-[14px] font-bold text-[#1B2559] pb-4 border-b border-gray-100 mb-6 shrink-0">Inventory & Stock</h3>
      
      <div className="flex-1 flex flex-col justify-center space-y-8 min-h-0">
        <div className="flex flex-col border-b border-gray-50/80 pb-4">
          <span className="text-[11px] font-semibold text-[#1B2559] tracking-tight mb-1">Total Stock Value</span>
          <div className="text-left">
            <span className="text-[15px] xl:text-[18px] font-black text-[#1B2559] leading-[1.2] block whitespace-normal break-words">
              {isLoading ? "..." : formatValue(results.totalStockValue)}
            </span>
          </div>
        </div>
        
        <div className="flex flex-col pb-2">
          <span className="text-[11px] font-semibold text-[#1B2559] tracking-tight mb-1">Low Stock Items</span>
          <div className="text-left">
            <span className="text-[15px] xl:text-[18px] font-black text-[#1B2559] leading-[1.2] block">
              {isLoading ? "..." : (results.lowStockItems || 0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};